export const NotFaund = () => {
    return (
        <div>
            This page does not exist.
        </div>
    );
};